export default __webpack_public_path__ + "static/media/image 118.441de5a9.png";